import { z } from 'my-zod'
import { transferModel } from './transfer-model'

export const transferSystemView = transferModel.augment({
  netAmount: z.number(),
  isReversed: z.boolean()
})

export type transferSystemView = z.infer<typeof transferSystemView>
